'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _antd = require('@adparlor-devops/antd');

var _isEmpty = require('lodash/isEmpty');

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = require('react-intl');

require('./ReportManagement.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReportManagement = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(ReportManagement, _Component);

  function ReportManagement() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ReportManagement);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ReportManagement.__proto__ || (0, _getPrototypeOf2.default)(ReportManagement)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      tooltipVisible: true
    }, _this.tooltipVisibleToggle = function (visible) {
      _this.setState({
        tooltipVisible: !visible
      });
    }, _this.onDelete = function (e, reportId) {
      e.stopPropagation();
      _this.props.savedReports.actions.onDelete(reportId);
    }, _this.onFav = function (e, reportId) {
      var favId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      e.stopPropagation();
      _this.props.savedReports.actions.onFav(reportId, favId);
    }, _this.onSelect = function (reportId) {
      if (reportId) _this.props.savedReports.actions.onSelect(reportId);
    }, _this.onChange = function (value) {
      _this.props.savedReports.actions.onSelect(value[1]);
    }, _this.renderFavIcon = function (reportId) {
      var favId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var maxAmountOfFavouritesReached = arguments[2];

      if (maxAmountOfFavouritesReached && favId === null) {
        // Trying to favourite when max amount of favourite is reached
        var maxFavourites = _this.props.savedReports.maxFavourites;

        return _react2.default.createElement(
          _antd.Tooltip,
          {
            title: _react2.default.createElement(_reactIntl.FormattedMessage, {
              id: 'Mega-blocs.ReportManagement.savedReports.Tooltip.maxFavourites.label',
              defaultMessage: 'You\u2019ve reached {maxFavourites} maximum saved favorites.',
              values: { maxFavourites: maxFavourites }
            }),
            placement: 'right'
          },
          _react2.default.createElement(_antd.Icon, { type: 'star', className: 'disable-star', onClick: function onClick(e) {
              return e.stopPropagation();
            } })
        );
      }
      return _react2.default.createElement(_antd.Icon, { onClick: function onClick(e) {
          return _this.onFav(e, reportId, favId);
        }, type: 'star', className: favId ? 'checked' : '' });
    }, _this.noSavedReportsAvailableOption = function () {
      return {
        value: 'noSavedReportsAvailable',
        label: _react2.default.createElement(
          'div',
          { onClick: function onClick(e) {
              return e.stopPropagation();
            } },
          _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'Mega-blocs.ReportManagement.savedReports.noSavedReportsAvailable.label',
            defaultMessage: 'No Saved Reports Available'
          })
        )
      };
    }, _this.optionsBuilder = function () {
      var options = [];
      var _this$props = _this.props,
          platform = _this$props.platform,
          savedReports = _this$props.savedReports;

      var platformFavourites = savedReports.favourites[platform];
      var anyFavouritesAvailable = !(0, _isEmpty2.default)(platformFavourites);
      var maxAmountOfFavouritesReached = anyFavouritesAvailable ? platformFavourites.length >= savedReports.maxFavourites : false;

      if (savedReports && savedReports.data) {
        var savedReportOptions = {
          value: 'savedReports',
          label: 'Saved Reports',
          children: savedReports.data.length === 0 ? [_this.noSavedReportsAvailableOption()] : savedReports.data.map(function (report) {
            var isFav = platformFavourites.find(function (fav) {
              return report.id === fav.reportId;
            });

            return {
              value: report.id,
              label: _react2.default.createElement(
                'div',
                { className: 'saved-report-label' },
                _react2.default.createElement(
                  'span',
                  null,
                  report.key
                ),
                _react2.default.createElement(
                  'span',
                  { className: 'action-icons' },
                  _this.renderFavIcon(report.id, isFav && isFav.id, maxAmountOfFavouritesReached),
                  _react2.default.createElement(
                    _antd.Popconfirm,
                    {
                      onVisibleChange: function onVisibleChange(visible) {
                        return _this.tooltipVisibleToggle(visible);
                      },
                      title: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'Mega-blocs.ReportManagement.savedReports.Popconfirm.onDelete.label',
                        defaultMessage: 'Are you sure you want to delete this report?'
                      }),
                      placement: 'right',
                      onConfirm: function onConfirm(e) {
                        return _this.onDelete(e, report.id);
                      },
                      getPopupContainer: function getPopupContainer(triggerNode) {
                        return _this.props.determinePopupContainerLocation(triggerNode);
                      }
                    },
                    _react2.default.createElement(_antd.Icon, { onClick: function onClick(e) {
                        return e.stopPropagation();
                      }, type: 'delete' })
                  )
                )
              )
            };
          })
        };

        options.push(savedReportOptions);
      }

      return options;
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ReportManagement, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var extraCascaderProps = {};

      if (this.props.isModalVisible || !this.state.tooltipVisible) {
        extraCascaderProps.popupVisible = true;
      }

      return _react2.default.createElement(
        'div',
        { className: 'ReportManagement__Component' },
        _react2.default.createElement(_antd.Cascader, (0, _extends3.default)({}, extraCascaderProps, {
          value: [],
          onChange: function onChange(value) {
            return _this2.onChange(value);
          },
          placeholder: 'Select Reports',
          options: this.optionsBuilder(),
          getPopupContainer: function getPopupContainer(triggerNode) {
            return _this2.props.determinePopupContainerLocation(triggerNode);
          }
        }))
      );
    }
  }]);
  return ReportManagement;
}(_react.Component), _class.propTypes = {
  savedReports: _propTypes2.default.shape({
    data: _propTypes2.default.arrayOf(_propTypes2.default.shape({
      id: _propTypes2.default.number.isRequired,
      advertiser_id: _propTypes2.default.number.isRequired,
      key: _propTypes2.default.string.isRequired,
      value: _propTypes2.default.string.isRequired
    })),
    maxFavourites: _propTypes2.default.number.isRequired,
    actions: _propTypes2.default.shape({
      onSelect: _propTypes2.default.func,
      onFav: _propTypes2.default.func,
      onDelete: _propTypes2.default.func
    }).isRequired
  }).isRequired,
  isModalVisible: _propTypes2.default.bool.isRequired,
  platform: _propTypes2.default.string.isRequired,
  determinePopupContainerLocation: _propTypes2.default.func.isRequired
}, _temp2);
exports.default = ReportManagement;


//////////////////
// WEBPACK FOOTER
// ./~/@adparlor-devops/mega-blocs/lib/components/ReportManagement/ReportManagement.js
// module id = 2708
// module chunks = 1